

import { SpacerIcon } from "../Icons/ComponentIcons";
import {  ResizeableType, WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import BlogHeadingRender, { RenderBlogDetails, RenderBlogEditorOverlay } from "./BlogHeadingRender";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "../Data/WBData";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { GetReadTime } from "../InlineTextEditorFull";
import { BlogPostInfo, CreateGenericPost } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import "vagaro-website-rendering/src/components/Styles/BlogHeadingStyle.css";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";

const missingImage = `https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc0dc7308f897.ssl.cf2.rackcdn.com/Websitebuilder/20240916213555.png`;

const BlogAtts = {
  heroImage:"blog-hero-image",
  author:"blog-author",
  title : "blog-title"

}

//represents all keys that should be synced between the component and the site styling
export const BlogAndStylingSyncKeys = [
  "blog-hero-layout",
  "blog-show-table-contents",
  "blog-show-categories",
  "blog-show-tags",
  "blog-show-author",
  "blog-show-date",
  "blog-show-readtime",
  "blog-image-radius",
  
]


export default class BlogHeading extends WBComponent {

    


    constructor(){
        super();
        this.typename =wBComponentTypeNames.blogHeading;
        this.displayName = "Blog Post";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = ["manage-post","blog-hero-layout","blog-hero-image-pos","blog-show-categories","blog-show-tags","blog-show-author","blog-show-date","blog-show-readtime","blog-image-radius"];
        this.editList = [...this.primaryEditAttributes,"blog-tags","blog-cats","blog-author","blog-title"];
        this.contentEditable = false;
        this.icon = <SpacerIcon/>
        this.isStatic = true;
        this.resizeType = ResizeableType.None;
        this.hideAdvancedSettings = true;

        
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

  

        return [
            new AttributeDefinition("blog-hero-image","Hero Image","",AttributeInputType.ImageField),
            new AttributeDefinition("blog-hero-image-pos","Hero Image Position","",AttributeInputType.MeasurementField,
              [
              
                {label:"Top",value:"0%"},
                {label:"Center",value:""},
                {label:"Bottom",value:"100%"}
                
            ],{min:0,max:100,step:.1,unit:"%"}),
            new AttributeDefinition("blog-author","Author","",AttributeInputType.InputFiled),
            new AttributeDefinition("blog-title","Title","",AttributeInputType.Ignore),
            new AttributeDefinition("blog-hero-layout","Layout","",AttributeInputType.SelectField,
              [
                {label:"Above",value:""},
                {label:"Below",value:"below"},
                {label:"Full",value:"full"},
                {label:"Overlay",value:"overlay"},
         
                
            ],{min:0,max:100,step:.1,unit:"%"}),
            new AttributeDefinition("blog-author","Author","",AttributeInputType.InputFiled),
            new AttributeDefinition("manage-post","Manage Post","",AttributeInputType.BlogSettingsButton),
            
            new AttributeDefinition("blog-show-table-contents","Table of Contents","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Hide",value:"hide"},

            
            ],null,AttributeTargetType.Component,"Turn all Heading 2s into a table of contents with links to each section"),
                        
            new AttributeDefinition("blog-show-author","Author Display","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Name Only",value:"name-only"},
              {label:"Hide",value:"hide"},
  
            ]),
            new AttributeDefinition("blog-show-categories","Categories","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Hide",value:"hide"},
  
            ]),
            new AttributeDefinition("blog-show-tags","Tags","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Hide",value:"hide"},
  
            ]),
            new AttributeDefinition("blog-show-date","Date","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Hide",value:"hide"},
  
            ]),
            new AttributeDefinition("blog-show-readtime","Read Time","",AttributeInputType.ButtonField,[
              {label:"Show",value:""},
              {label:"Hide",value:"hide"},
  
            ]),


            new AttributeDefinition("blog-image-radius","Image Radius (All Images)","",AttributeInputType.MeasurementField,[{label:"Auto",value:""},{label:"S",value:"5px"},{label:"M",value:"10px"},{label:"L",value:"16px"}],{min:0,max:50,step:1,unit:"px"}),
        ];
    }

    RenderLayout({component,screenSize,isEditor,userContext,isLivePublish}:WBRenderProps)
     {

 

      let atts = GetNodeDomAttributes("blog-header ",component,screenSize,isEditor);
      let img = getNodeComponentAttributeValue(component,"blog-hero-image","");
      if(img.length<2)
        img = missingImage;

      let author = getNodeComponentAttributeValue(component,"blog-author","Anonymous");

      let title = getNodeComponentAttributeValue(component,"blog-title","Untitled");

      let showAuthorName = getNodeComponentAttributeValue(component,"blog-show-author","")!="hide";

      let showTags = getNodeComponentAttributeValue(component,"blog-show-tags","")!="hide";
      let showCategories = getNodeComponentAttributeValue(component,"blog-show-categories","")!="hide";
      let showDate = getNodeComponentAttributeValue(component,"blog-show-date","")!="hide";
      let showReadTime = getNodeComponentAttributeValue(component,"blog-show-readtime","")!="hide";

      let imgPos=  getNodeComponentAttributeValue(component,"blog-hero-image-pos","");

      let layout = getNodeComponentAttributeValue(component,"blog-hero-layout","");

      let overlayed = layout == "overlay";

      let designer =  (window as any).webDesigner;
      let postInfo:BlogPostInfo = designer?.state?.postInfo??CreateGenericPost();

      // if(limitHeroWidth){
      //   atts.style = {...atts.style,padding:"1em 8px"};
      // }
      // else{
      //   atts.style = {...atts.style,paddingBottom:"1em"};
      // }
      let read = 0;
      if(isEditor){
         read = GetReadTime();
        postInfo.readTime = read;

      }


      if(!isEditor&&isLivePublish){
        return <>
        <style>{`.blog-heading-image{
        object-position: 50% ${imgPos??"50%"};
        }`}</style>
        <BusinessPlaceHolder node={component} dataKey="blogsync" layout={layout} classNames={"force-hidden"} /></>;
      }




      return (
        <div {...atts}>
         
             <style>{`.blog-heading-image{
          object-position: 50% ${imgPos??"50%"};
          }`}</style>
           
          <RenderBlogEditorOverlay component={component}
            overlayed = {overlayed}
          />
          <img className="blog-heading-image" src={img} alt={title} />
          <div className="blog-overlay"></div>
           <div className="w-full blog-details-wrapper">
          <RenderBlogDetails
                isEditor={isEditor}
                context={userContext}
                key = {postInfo.id??""}
                authorId={postInfo.encAuthor??""}
                //  title={ title}
                 profileImg={""}
                 author={showAuthorName ? author??"Anonymous" : undefined}
                 readTime={showReadTime?read:undefined}
                 date={showDate?postInfo.publishDateStr??"Unpublished":undefined}
                 categories={showCategories?postInfo.category:undefined}
                 tags={showTags?postInfo.tags:undefined}
               >
                <BlogHeadingRender
                       component={component}
                       screenSize={screenSize}
                       isEditor={isEditor}
                       userContext={userContext}
                       children={undefined}
                     />
                 </RenderBlogDetails>
               </div>
        </div>


      )

   


    }

    OnApplyAttribute(component: AttributeCollection, attribute: string, value: string, manager: WebDesigner): void {
      
      if(BlogAndStylingSyncKeys.includes(attribute)){

        let data = manager.state.siteData;

        setNodeComponentAttributeValue(data.siteStyling.blogInfo,attribute,value);

        data.onUpdateStyle();
      }
      

    }



}




//updates the blog post info with values from the blog heading attribute collection
export function ApplyBlogInfoFromBlogHeading(node:LayoutNode,info:BlogPostInfo):BlogPostInfo{



  info.image = getNodeComponentAttributeValue(node,BlogAtts.heroImage);
  info.title = getNodeComponentAttributeValue(node,BlogAtts.title,"Untitled");
  info.author = getNodeComponentAttributeValue(node,BlogAtts.author,"Anonymous");


  return info;
}

//updates the blog heading attribute collection with values from the blog post info
export function ApplyBlogHeadingFromBlogInfo(node:LayoutNode,info:BlogPostInfo):LayoutNode{
  
    setNodeComponentAttributeValue(node,BlogAtts.heroImage,info.image);
    setNodeComponentAttributeValue(node,BlogAtts.title,info.title);
    setNodeComponentAttributeValue(node,BlogAtts.author,info.author);
  
    return node;

}

